import { FC, createPortal } from "preact/compat";
import { useDocumentPiP } from "~/hooks";
import { DocumentPictureInPictureProps } from "./interfaces";

const DocumentPictureInPicture: FC<DocumentPictureInPictureProps> = ({
    id,
    children,
}) => {
    const { active, pipWindow } = useDocumentPiP(id);
    const pip = pipWindow.value;

    if (!pip || !active.value) {
        return null;
    }

    return createPortal(children, pip.document.body);
};

export default DocumentPictureInPicture;
